import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import EmployeeConfig from '../../../../services/api/EmployeeConfig'

const { Employee_NotificationsActionHistory_Endpoints } = EmployeeConfig
const SELF_BFF_API = process.env.REACT_APP_SELF_BFF_BASE_URL

const resetState = {
  pageNumber: 0,
  activeFilters: {},
  activeSearch: '',
  activeSort: {},
  updatedItem: {},
}

export const notificationActionHistoryResetAlertHandler = createAsyncThunk(
  'notificationActionHistory/notificationActionHistoryResetAlertHandler',
  async () => ({}),
)

export const getNotificationActionHistoryList = createAsyncThunk(
  'notificationActionHistory/getNotificationActionHistoryList',
  async ({ queries, resetQueries }, { rejectWithValue, getState }) => {
    const { notificationActionHistory } = getState();
    const apiUri = Employee_NotificationsActionHistory_Endpoints()
    const queryObject = createReqHelper(
      notificationActionHistory,
      resetQueries ? resetState : queries,
    )
    const response = await axios.get(`${SELF_BFF_API}/${apiUri.notificationsActionHistory}`, {
      params: queryObject,
    });

    if (response.status >= 300) {
      return rejectWithValue(response)
    }

    return {
      response: response.data,
      queries: resetQueries ? resetState : queries,
    };
  },
)

function createReqHelper(store, filters = {}) {
  const copyStore = { ...store, ...filters };

  const {
    pageSize,
    pageNumber,
    activeSearch,
  } = copyStore

  const response = {
    search: activeSearch,
    page_number: pageNumber || 0,
    page_size: pageSize,
  }

  return response
}
